module.exports = __webpack_public_path__ + "static/img/product_info.9652cd3e.jpg";